export const TRANSLATIONS = {
  COMMON: {
    SEARCH_LOCATION: 'Vyhledat lokaci',
    NO_RESULTS_FOUND: 'Žádné výsledky nebyly nalezeny',
    CLOSE: 'Zavřít',
    SOCIAL_SERVICE_PERMISSIONS: 'Oprávnění pro službu',
    SELECT_SERVICE_AND_LOCATION: 'Vyberte službu a lokaci',
    CHOSEN_SERVICE_AND_LOCATION: 'Vybraná lokace byla úspěšně změněna',
    FILTER_WORKERS_ONLY: 'Pouze pracovníci',
    FILTER_ROLES: 'Vyfiltrovat podle role',
    SEARCH: 'Vyhledávání',
    ADD_USER: 'Přidat uživatele',
    USER_MANAGEMENT: 'Správa uživatelů',
    ROLE: 'Role',
    TOOLTIP_ADD_USER: 'Přidat nového uživatele',
    TOOLTIP_SEARCH: 'Vyhledávání uživatelů',
    TOOLTIP_ROLE: 'Vyberte roli pro filtrování',
    TOOLTIP_LOCATION: 'Vyberte lokaci pro filtrování',
    TOOLTIP_EDIT: 'Upravit uživatele',
    TOOLTIP_DELETE: 'Smazat uživatele',
    LOCATION: 'Lokace',
    ONLY_WORKERS: 'Pouze pracovníci',
    EDIT_USER: 'Upravit uživatele',
    DELETE_USER: 'Smazat uživatele',
    TOUR_LOCATION_SELECT_CONTENT:
      'Zde si můžeš zvolit, ve které alokaci právě pracuješ.<br><br>Alokace odpovídají jednotlivým lokacím (pobočkám) v dané sociální službě. Tato volba ovlivňuje, s jakými daty budeš v aplikaci pracovat.<br><br>Pokud máš přístup jen k jedné alokaci, vybrali jsme ji automaticky.',
    TOUR_LOCATION_SELECT_TITLE: 'Výběr aktivní alokace',
    TOUR_UNDERSTAND_BUTTON: 'Rozumím',
  },
  ASSISTANCE: {
    TABLE: {
      globalFilterPlaceholder: 'Vyhledat v asistencích',
      HEADERS: {
        clientName: 'Klient',
        plannedFrom: 'Plán',
        plannedDurationMinutes: 'Plán délka',
        realizedFrom: 'Reál',
        realizedDurationMinutes: 'Reál délka',
        shortDescription: 'Krátký popis',
        coordinatorNote: 'Poznámka koordinace',
        assistantNames: 'Asistenti',
        statusId: 'Stav',
        keyCoordinatorName: 'Koordinátor',
        clientWorkgroupName: 'PS K',
        assistantsWorkgroupsNames: 'PS A',
        isSentToClient: 'OK',
        isNotToBePrimarilyAssigned: 'PN',
        isLateOrder: 'PO',
        activeExchangeEnrollmentsCount: 'Burza',
      },
    },
  },
} as const

// Export the translations for the loader
export const cs = TRANSLATIONS
